<template>
    <div>
        <button
            type="button"
            class="hidden xl:inline-block btn btn-md is-danger is-ghost"
            @click="$modal.show('delete-unsigned-addresses')"
        >
            Radera osignerade adresser
        </button>
        <button
            type="button"
            class="list-item is-danger xl:hidden"
            @click="$modal.show('delete-unsigned-addresses')"
        >
            Radera osignerade adresser
        </button>

        <adaptive-form-modal
            name="delete-unsigned-addresses"
            primary-button-text="Radera osignerade adresser"
            primary-button-class="is-danger"
            title="Radera osignerade adresser"
            :redirect-to="redirectRoute"
            :action="actionRoute"
            method="delete"
        >
            <p>Vill du verkligen radera projektets alla osignerade adresser?</p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {

        props: {
            project: {
                type: Object,
                required: true,
            },
        },

        computed: {
            actionRoute() {
                return route('admin.sales-projects.unsigned-addresses.destroy', this.project);
            },
            redirectRoute() {
                return route('admin.sales-projects.addresses.index', this.project);
            },
        },
    };
</script>
